import React from 'react'
import 'react-notifications/lib/notifications.css'
import ResponsiveAppBar from './menu'
import { Container } from '@mui/material'
import PWA from './pwa'
import './layout.scss'

const Layout = ({ children }: any) => {
    return (
        <Container
            className='content'
            sx={{ flexGrow: 1, pt: 1, pb: 8 }}
            style={{
                position: 'relative',
                padding: 0
            }}
            maxWidth={false}
        >
            <ResponsiveAppBar />

            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <PWA />
            </div>
            {children}
        </Container>
    )
}

export default Layout